export const Confirmemail=()=>{
// Statusnachricht aus der URL abrufen
const urlParams = new URLSearchParams(window.location.search);
const statusMessage = urlParams.get('statusMessage');

return (
    <>
        Wunderbar die Anmeldung hat funtkioniert

    
        <div>
            <h1>React-Seite</h1>
            <p>Status: {statusMessage}</p>
        </div>
    
</>
)

}